import { MY } from 'config/fe-routes';
import { Middleware } from 'redux';
import UserDac7Service from 'services/user-dac7.service';
import { USER_DAC7_ACTION_TYPE } from 'store/action-types/user-dac7.action-types';
import { setUser } from 'store/actions/user.actions';
import { USER_DAC7_ACTION } from 'store/actions/user-dac7.actions';
import { StoreData } from 'store/root-reducer';
import { DAC7FormRequiredFields, PrivatePersonDac7FormField, UserAccountType } from 'types/user.types';
import { redirectTo } from 'utils/route-helpers';

export const userDac7ServiceMiddleware: Middleware = ({ getState }) => {
  return (next) => async (action) => {
    switch (action.type) {
      case USER_DAC7_ACTION_TYPE.SET_INFORMATION: {
        const { field, value } = action.payload;
        const { userData } = getState();
        const { accountType, data, errors } = userData.userDac7Form;

        if (value) {
          if (errors[accountType] && errors[accountType][field]) {
            USER_DAC7_ACTION.clearError(field);
          }

          if (field === PrivatePersonDac7FormField.residencyCountry) {
            USER_DAC7_ACTION.clearError(PrivatePersonDac7FormField.vat);
            USER_DAC7_ACTION.clearError(PrivatePersonDac7FormField.residencyCountry);
          }

          if (field === PrivatePersonDac7FormField.fullName) {
            const validFullName = value?.split(' ').filter((namePart) => namePart).length > 1;

            if (!validFullName) {
              USER_DAC7_ACTION.setInvalidValueError(field);
            }
          }

          break;
        }

        if (DAC7FormRequiredFields[accountType].includes(field)) {
          USER_DAC7_ACTION.setRequiredError(field);

          break;
        }

        if (accountType === UserAccountType.PRIVATE_PERSON) {
          const isEstoniaSelected = data[UserAccountType.PRIVATE_PERSON][PrivatePersonDac7FormField.residencyCountry] === 'EE';

          if (isEstoniaSelected && [PrivatePersonDac7FormField.vat, PrivatePersonDac7FormField.idCode]?.includes(field)) {
            if (field === PrivatePersonDac7FormField.idCode && !value) {
              USER_DAC7_ACTION.setRequiredError(field);

              break;
            }
          }

          if (
            (!isEstoniaSelected &&
              field === PrivatePersonDac7FormField.idCode &&
              !data[UserAccountType.PRIVATE_PERSON][PrivatePersonDac7FormField.vat]) ||
            (!isEstoniaSelected &&
              field === PrivatePersonDac7FormField.vat &&
              !data[UserAccountType.PRIVATE_PERSON][PrivatePersonDac7FormField.idCode])
          ) {
            USER_DAC7_ACTION.setConditionallyRequiredError(field);

            break;
          }
        }
        break;
      }
      case USER_DAC7_ACTION_TYPE.SUBMIT_CONFIRMATION: {
        const { userData } = getState() as StoreData;
        const { accountType, data, isValid } = userData.userDac7Form;

        if (!isValid) {
          break;
        }

        try {
          await UserDac7Service.post({ accountType, data: data[accountType] });
          USER_DAC7_ACTION.setFormSubmitted();
          userData.user.dac7_filled = true;
          setUser({ ...userData.user });
          redirectTo(MY.SETTINGS_PROFILE_DAC7_SUCCESS());
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log({ error });
        }

        break;
      }
    }

    next(action);
  };
};
